<div
  class="tag-container"
  [ngClass]="{ hovered: hovered, clicked: clicked }"
  (mouseleave)="hovered = false"
  (mouseenter)="hovered = true"
  (click)="onClick()"
  >
  <mat-form-field class="tag-field" appearance="outline">
    <mat-chip-grid #chipGrid>
      @for (tag of tags; track tag) {
        <app-tag-chip (removeClicked)="removeTag(tag)" [tag]="tag"></app-tag-chip>
      }
      <input
        placeholder="Add tag..."
        #tagInput
        [matChipInputFor]="chipGrid"
        [formControl]="tagControl"
        [matAutocomplete]="auto"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        (matChipInputTokenEnd)="addTag($event)"
        (focus)="autoCompleteTrigger.openPanel()"
        />
    </mat-chip-grid>
    <mat-autocomplete
      #auto="matAutocomplete"
      (optionSelected)="selectTag($event)"
      autoActiveFirstOption
      class="auto-complete"
      >
      @for (tag of filteredTags | async; track tag) {
        <mat-option (mousedown)="markClicked()" [value]="tag"
          >{{ tag.name }} @if (tag.category) {
          <span class="category"> : {{ tag.category.name }}</span>
          }</mat-option
          >
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>
